import { ComponentRef, ViewContainerRef } from "@angular/core";
import { Observable } from "rxjs";
import {IFunnelValidations, IFunnelRequest, IFunnelFlowResponse } from "src/app/domain/interfaces/funnel/interface-funnel";
import { IFunnelResponse } from "src/app/domain/interfaces/funnel/interface-funnel-response";
import { FunnelStep } from "../funnel-step-enum";
import { FunnelFlow } from "../register-funnels/funnel-flow-register";

export abstract class FunnelGateway {
    abstract ValidateFunnel(funnelRequest: IFunnelRequest): Observable<IFunnelResponse>;
    abstract GetUserRegister(): Observable<any>;
    abstract ClearUserRegister(FunnelFlow?: FunnelFlow): void;
    abstract ValidateRegisterLimitTime(): void;
    abstract SaveUserRegisterInStorage(FunnelFlow?: FunnelFlow, NextStep?: FunnelStep): void;
    abstract SendRegisterForm(FunnelFlow?: FunnelFlow, NextStep?: FunnelStep, hideLoading?: boolean): Observable<IFunnelFlowResponse>;
    abstract GetUSAStates(): Observable<Array<{ Code: string, Name: string }>>;
    abstract ValidateFunnelMessages(FunnelFlow: FunnelFlow, funnelCodeResponse: string): void;
    abstract ValidateFunnelMessage(FunnelFlow: FunnelFlow): void;
    abstract GetFunnelMessage(FunnelMessageCode: string): Observable<IFunnelValidations>
    abstract ReplaceRegExp(input: string, type: string): void;
    abstract SendValidateEmailAPI(FunnelFlow?: FunnelFlow): Observable<{ data?: { isValid: boolean, validationCode: string, isAvailableResource?: boolean} }>;
    abstract SendUpdateCustomerEmail(FunnelFlow?: FunnelFlow): Observable<{ data?: boolean }>;
}